(() => {
    /******************************************************************/
    /* GLOBALS
    /******************************************************************/

    const cheeringBarProgressBackground = document.querySelector('.Cart__cheering-bar-progress-background');
    const DIGITAL_PRODUCTS_LIST = [8560646062347]; // Anpassen falls mehrere Gutscheine
    let scData;
    let shippingRate;
    let minSubtotalPriceValue;
    let shippingMin;
    let freeGiftMin;
    let freeGiftMin2;
    let digitalProductsValue = 0.0;
    let hasOnlyDigitalProducts = false;
    let currentCountry;
    let currency;

    // check geo location for shipping rates
    fetch('/browsing_context_suggestions.json')
        .then(response => response.json())
        .then(json => {
            currentCountry = json.detected_values.country.handle;

            switch (currentCountry) {
                case 'DE':
                    minSubtotalPriceValue = Math.max(
                        shippingrates.de.minSubtotalPriceValue, 
                        shippingrates.de.minSubtotalPriceValue2,
                        shippingrates.de.minSubtotalPriceValue3
                    );
                    shippingMin = shippingrates.de.minSubtotalPriceValue;
                    freeGiftMin = shippingrates.de.minSubtotalPriceValue2;
                    freeGiftMin2 = shippingrates.de.minSubtotalPriceValue3;
                    shippingRate = shippingrates.de.priceValue;
                    break;
                case 'AT':
                    minSubtotalPriceValue = Math.max(
                        shippingrates.at.minSubtotalPriceValue, 
                        shippingrates.at.minSubtotalPriceValue2,
                        shippingrates.at.minSubtotalPriceValue3
                    );
                    shippingRate = shippingrates.at.priceValue;
                    shippingMin = shippingrates.at.minSubtotalPriceValue;
                    freeGiftMin = shippingrates.at.minSubtotalPriceValue2;
                    freeGiftMin2 = shippingrates.at.minSubtotalPriceValue3;
                    break;
                case 'CH':
                    minSubtotalPriceValue = Math.max(
                        shippingrates.ch.minSubtotalPriceValue, 
                        shippingrates.ch.minSubtotalPriceValue2,
                        shippingrates.ch.minSubtotalPriceValue3
                    );
                    shippingRate = shippingrates.ch.priceValue;
                    shippingMin = shippingrates.ch.minSubtotalPriceValue;
                    freeGiftMin = shippingrates.ch.minSubtotalPriceValue2;
                    freeGiftMin2 = shippingrates.ch.minSubtotalPriceValue3;
                    break;
                default:
                    minSubtotalPriceValue = 0;
                    shippingRate = 0;
                    shippingMin = 0;
                    freeGiftMin = 0;
                    freeGiftMin2 = 0;
                    break;
            }

            // load cheeringbar
            cheeringBar(false, 0)

            if (currentCountry !== "DE" && currentCountry !== "AT" && currentCountry !== "CH") {
                setTimeout(() => {
                    handleOtherLocations();
                }, 1800);
            }
        });

    document.addEventListener('DOMContentLoaded', () => {
        scData = JSON.parse(sessionStorage.getItem("scDiscountData"));

        if (!scData?.code) {
            cheeringBar(false, 0);
        }

        document.addEventListener('theme:loading:end', () => {
            // add loading class
            document.querySelector('#sidebar-cart').classList.add('loading');

            setTimeout(() => {
                if (document.querySelector('#sidebar-cart .Drawer__Footer .Drawer__Footer__Coupon-title')) {
                    document.querySelector('#sidebar-cart .Drawer__Footer .Drawer__Footer__Coupon-title').addEventListener('click', () => {
                        toggleDCart();
                    });
                }
                
                // handle other locations
                if (currentCountry !== "DE" && currentCountry !== "AT" && currentCountry !== "CH") {
                    handleOtherLocations();
                }

                // if no discount is added, remove loading class
                if (!scData?.code) {
                    document.querySelector('#sidebar-cart').classList.remove('loading');
                    cheeringBar(false, 0);
                    shippingRateAmount();
                    totalCalculation();
                }
            }, 900);
        });
    });

    /******************************************************************/
    /* CHECK DIGITRAL PRODUCTS AND SUM THEIR VALUE FOR CALCULATIONS
    /******************************************************************/

    const checkDigitalProducts = () => {
        digitalProductsValue = 0.0;
        hasOnlyDigitalProducts = false;
        
        const cartItems = document.querySelectorAll('#sidebar-cart .Cart__ItemList .CartItemWrapper');
        
        if (cartItems.length === 0) {
            return;
        }

        let totalDigitalItems = 0;
        let totalItems = cartItems.length;

        cartItems.forEach((cartItem) => {
            const productId = parseInt(cartItem.dataset.productId);
            
            if (DIGITAL_PRODUCTS_LIST.includes(productId)) {
                digitalProductsValue += parseFloat(cartItem.dataset.price / 100);
                totalDigitalItems++;
            }
        });

        // Prüfen ob ALLE Items digitale Produkte sind
        hasOnlyDigitalProducts = (totalDigitalItems === totalItems) && (totalItems > 0);
    };
    
    /******************************************************************/
    /* HANDLE OTHER LOCATIONS
    /******************************************************************/

    const handleOtherLocations = () => {
        document.querySelector("#sidebar-cart .Cart__cheering-bar").style.display = "none";

        if (document.querySelector("#sidebar-cart .Drawer__Footer") !== null) {
            document.querySelector("#sidebar-cart .Drawer__Footer").style.height = "335px";
            document.querySelector("#sidebar-cart .Drawer__Footer__Total").style.display = "none";
            document.querySelector("#sidebar-cart .Drawer__Footer__Delivery").innerHTML = "* Die Versandkosten werden im Checkout berechnet."
            document.querySelector("#sidebar-cart .Drawer__Footer__Delivery").style.bottom = "20px";
        }
    }

    /******************************************************************/
    /* CHEERING BAR
    /******************************************************************/

    const cheeringBar = (isDcartCalculation, scSubTotalPrice) => {
        checkDigitalProducts();

        let cartDefaults = {
            "cartTotalPrice": document.querySelector('.Cart__values').dataset.cartTotalPrice,
            "cartTotalPriceFloat": document.querySelector('.Cart__values').dataset.cartTotalPriceFloat,
            "freeShippingText": document.querySelector('.Cart__values').dataset.freeShippingText,
            "freeShippingFromText": document.querySelector('.Cart__values').dataset.freeShippingFromText,
            "freeGiftText": document.querySelector('.Cart__values').dataset.freeGiftText,
            "freeGiftFromText": document.querySelector('.Cart__values').dataset.freeGiftFromText,
            "successMessageOneGift": document.querySelector('.Cart__values').dataset.successMessageOneGift,
            "successMessageTwoGifts": document.querySelector('.Cart__values').dataset.successMessageTwoGifts,
            "isFreeShipping": document.querySelector('.Cart__values').dataset.isFreeShipping,
            "progressMessageOneGift": document.querySelector('.Cart__values').dataset.progressMessageOneGift,
        }

        let remainingPrice;
        let remainingPriceFormatted;
        let cheeringBarPercentage;

        if (isDcartCalculation) {
            remainingPrice = minSubtotalPriceValue - (parseFloat(scSubTotalPrice) - parseFloat(digitalProductsValue));
            cheeringBarPercentage = ((scSubTotalPrice - digitalProductsValue) / parseFloat(minSubtotalPriceValue)) * 100;
        } else {
            remainingPrice = minSubtotalPriceValue - (parseFloat(cartDefaults.cartTotalPriceFloat) - parseFloat(digitalProductsValue));
            cheeringBarPercentage = ((parseFloat(cartDefaults.cartTotalPriceFloat) - digitalProductsValue) / parseFloat(minSubtotalPriceValue)) * 100;
        }

        remainingPriceFormatted = remainingPrice.toFixed(2).toString().replace('.', ',');
        cheeringBarProgressBackground.style.width = cheeringBarPercentage + '%';

        // if percentage > 100 show free shipping
        if (cheeringBarPercentage >= 100) {
            document.querySelector('.Cart__cheering-bar-content span').textContent = cartDefaults.freeShippingText;
        } else {
            document.querySelector('.Cart__cheering-bar-content span').textContent = "Noch " + currency + remainingPriceFormatted + cartDefaults.freeShippingFromText;
        }

        function checkEligibility(mingift1, mingift2, minshipping, cartsubtotal, currency) {
            // Check if second gift threshold exists and is valid
            const hasSecondGift = mingift2 && mingift2 > 0 && !isNaN(mingift2);
            
            // Create array of all tiers with their values and labels
            const tiers = [
                { value: minshipping, label: 'free shipping', text: cartDefaults.freeShippingText, fromText: cartDefaults.freeShippingFromText },
                { value: mingift1, label: 'a free gift', text: cartDefaults.freeGiftText, fromText: cartDefaults.freeGiftFromText }
            ];
            
            // Only add second gift tier if it exists and is valid
            if (hasSecondGift) {
                tiers.push({ value: mingift2, label: 'a second gift', text: cartDefaults.freeGiftText, fromText: cartDefaults.freeGiftFromText });
            }

            // Sort tiers by value (ascending)
            tiers.sort((a, b) => a.value - b.value);

            // Check which tier the customer has reached
            // Check in order: free shipping -> first gift -> second gift
            if (hasSecondGift) {
                // Two gifts configured - check sequentially
                if (cartsubtotal >= mingift2 && cartsubtotal >= mingift1 && cartsubtotal >= minshipping) {
                    // All three benefits unlocked - free shipping and 2 gifts
                    document.querySelector('.Cart__cheering-bar-content span').textContent = cartDefaults.successMessageTwoGifts || `Kostenloser Versand & 2 Geschenke!`;
                } 
                else if (cartsubtotal >= mingift1 && cartsubtotal >= minshipping) {
                    // Free shipping and first gift reached, show progress to second gift
                    const remaining = (mingift2 - cartsubtotal).toFixed(2).replace('.', ',');
                    document.querySelector('.Cart__cheering-bar-content span').textContent = `Noch ${currency}${remaining} bis zum 2. Geschenk`;
                }
                else if (cartsubtotal >= minshipping) {
                    // Free shipping reached, show progress to first gift
                    const remaining = (mingift1 - cartsubtotal).toFixed(2).replace('.', ',');
                    const template = cartDefaults.progressMessageOneGift || 'Noch [amount] bis zum 1. Geschenk';
                    document.querySelector('.Cart__cheering-bar-content span').textContent = template.replace('[amount]', `${currency}${remaining}`);
                }
                else {
                    // Free shipping not reached yet, show progress to free shipping
                    const remaining = (minshipping - cartsubtotal).toFixed(2).replace('.', ',');
                    document.querySelector('.Cart__cheering-bar-content span').textContent = `Noch ${currency}${remaining} bis zum kostenlosen Versand`;
                }
            }
            else {
                // Only one gift or no second gift configured - use original logic
                if (cartsubtotal >= tiers[1].value) {
                    // Two benefits unlocked, show success message
                    document.querySelector('.Cart__cheering-bar-content span').textContent = cartDefaults.successMessageOneGift || `Kostenloser Versand & 1 Geschenk!`;
                } 
                else if (cartsubtotal >= tiers[0].value) {
                    // First benefit unlocked, show progress to second
                    const remaining = (tiers[1].value - cartsubtotal).toFixed(2).replace('.', ',');
                    document.querySelector('.Cart__cheering-bar-content span').textContent = `Noch ${currency}${remaining} ${tiers[1].fromText}`;
                } 
                else {
                    // No benefits yet, show progress to first tier
                    const remaining = (tiers[0].value - cartsubtotal).toFixed(2).replace('.', ',');
                    document.querySelector('.Cart__cheering-bar-content span').textContent = `Noch ${currency}${remaining} ${tiers[0].fromText}`;
                }
            }
        }

        // Example usage:
        if (isDcartCalculation) {
            checkEligibility(freeGiftMin, freeGiftMin2, shippingMin, (parseFloat(scSubTotalPrice) - parseFloat(digitalProductsValue)), currency);
        } else {
            checkEligibility(freeGiftMin, freeGiftMin2, shippingMin, (parseFloat(cartDefaults.cartTotalPriceFloat) - parseFloat(digitalProductsValue)), currency);
        }

        // show / hide cheering bar
        if (cheeringBarPercentage <= 0) {
            // document.querySelector('.Cart__cheering-bar').classList.remove('visible');
        } else {
            document.querySelector('.Cart__cheering-bar').classList.add('visible');
        }
    }

    /******************************************************************/
    /* DCART calculatations
    /******************************************************************/

    if (window.Shopify.currency.active == "EUR") {
        currency = "€";
    }

    window.addEventListener('sc:discount.init', function () {
        scData = JSON.parse(sessionStorage.getItem("scDiscountData"));

        setTimeout(() => {
            dCartCalculation();
        }, 200);

        setTimeout(() => {
            if (!scData.code) {
                shippingRateAmount();
                totalCalculation();
            }
        }, 1000);

        setTimeout(() => {
            if (document.querySelector('#sidebar-cart .Drawer__Footer .Drawer__Footer__Coupon-title')) {
                document.querySelector('#sidebar-cart .Drawer__Footer .Drawer__Footer__Coupon-title').addEventListener('click', () => {
                    toggleDCart();
                });
            }
        }, 750);
    });

    window.addEventListener('sc:discount.calculated', function () {
        dCartCalculation();
    });

    window.addEventListener('sc:discount.remove', function () {
        dCartCalculation();
    });

    const totalCalculation = () => {
        checkDigitalProducts();
        // total calculation without dcart
        let cartTotalPriceFloat = document.querySelector('.Cart__values').dataset.cartTotalPriceFloat;
        let shippingPrice = shippingRate;

        if (parseFloat(cartTotalPriceFloat) > 0) {
            // Wenn nur digitale Produkte im Cart sind, keine Versandkosten
            if (hasOnlyDigitalProducts || (cartTotalPriceFloat - digitalProductsValue) >= shippingMin) {
                shippingPrice = 0;
            }

            let subTotalPrice = document.querySelector('.Cart__values').dataset.cartTotalPriceFloat;
            let totalPrice = parseFloat(subTotalPrice) + parseFloat(shippingPrice);
            let subTotalPriceFormatted = currency + parseFloat(subTotalPrice).toFixed(2).toString().replace('.', ',');
            let formattedTotalPrice = currency + totalPrice.toFixed(2).toString().replace('.', ',');

            document.querySelector('.Drawer__Footer__SubtotalPrice').textContent = subTotalPriceFormatted;
            document.querySelector('.Drawer__Footer__Total span').textContent = formattedTotalPrice;
        }
    }

    const shippingRateAmount = () => {
        checkDigitalProducts();
        let cartTotalPriceFloat = document.querySelector('.Cart__values').dataset.cartTotalPriceFloat;

        let shippingRateFormatted = currency + shippingRate.toString().replace('.', ',');

        if (document.querySelector('.Drawer__Footer__Delivery span')) {
            // Wenn nur digitale Produkte im Cart sind, zeige "versandkostenfrei"
            if (hasOnlyDigitalProducts || (cartTotalPriceFloat - digitalProductsValue) >= shippingMin) {
                document.querySelector('.Drawer__Footer__Delivery span').classList.add('free-shipping');
                document.querySelector('.Drawer__Footer__Delivery span').textContent = "versandkostenfrei";
            } else {
                document.querySelector('.Drawer__Footer__Delivery span').classList.remove('free-shipping');
                document.querySelector('.Drawer__Footer__Delivery span').textContent = shippingRateFormatted;
            }
        }
    }

    const toggleDCart = () => {
        const cartSidebar = document.querySelector('#sidebar-cart');
        cartSidebar.classList.toggle('Drawer__Footer__CouponActive');
    }

    const dCartCalculation = () => {
        checkDigitalProducts();
        scData = JSON.parse(sessionStorage.getItem("scDiscountData"));
        document.querySelector('#sidebar-cart').classList.add('loading');

        setTimeout(() => {
            document.querySelector('#sidebar-cart').classList.remove('loading');
        }, 1000);

        // do calculation only if discount is added
        if (scData.stage === "complete" && scData.subtotalCents > 0 || scData.stage === "initial" && scData.subtotalCents > 0) {
            if (scData?.codes || scData.subtotal === scData.total) {
                setTimeout(() => {
                    let subTotalPrice = (scData.subtotalCents / 100).toFixed(2);
                    let scSubTotalPriceFloat =  parseFloat(subTotalPrice);
                    let shippingPrice = shippingRate;

                    // Wenn nur digitale Produkte im Cart sind, keine Versandkosten
                    if (hasOnlyDigitalProducts || (scSubTotalPriceFloat - digitalProductsValue) >= shippingMin) {
                        shippingPrice = 0;
                    }
                    
                    let scShippingRateFormatted = currency + shippingRate.toString().replace('.', ',');
                    let totalPrice = parseFloat(subTotalPrice) + parseFloat(shippingPrice);

                    let formattedTotalPrice = currency + totalPrice.toFixed(2).toString().replace('.', ',');
                    let saved;

                    if (scData.discount) {
                        saved = '-' + currency + scData?.discount.amount.toString().replace('.', ',');
                    }

                    cheeringBar(true, scSubTotalPriceFloat);

                    // savings
                    const savingsDiv = document.querySelector('.Drawer__Footer__Coupon-percentage');

                    if (savingsDiv) {
                        savingsDiv.textContent = saved;
                    }

                    // compare at price
                    if (scData.subtotal !== scData.total) {
                        document.querySelector('.Drawer__Footer__SubtotalPrice__CompareAt').textContent = scData.totalFormatted;
                    } else {
                        document.querySelector('.Drawer__Footer__SubtotalPrice__CompareAt').textContent = "";
                    }

                    // subtotal price
                    document.querySelector('.Drawer__Footer__SubtotalPrice').textContent = scData.subtotalFormatted;

                    // shipping price
                    // Wenn nur digitale Produkte im Cart sind, zeige "versandkostenfrei"
                    if (hasOnlyDigitalProducts || (scSubTotalPriceFloat - digitalProductsValue) >= shippingMin) {
                        document.querySelector('.Drawer__Footer__Delivery span').classList.add('free-shipping');
                        document.querySelector('.Drawer__Footer__Delivery span').textContent = "versandkostenfrei";
                    } else {
                        document.querySelector('.Drawer__Footer__Delivery span').classList.remove('free-shipping');
                        document.querySelector('.Drawer__Footer__Delivery span').textContent = scShippingRateFormatted;
                    }

                    // total price
                    document.querySelector('.Drawer__Footer__Total span').textContent = formattedTotalPrice;

                    // giftcard calculation
                    const scCodeInfoRow = document.querySelector('#scDiscountApp .sc_simple-info__row.sc_code-info');
                    const scCodePercentage = document.querySelector('.Drawer__Footer__Coupon-percentage');
                    const scCodeInfo = document.querySelector('#scDiscountApp .sc_simple-info__row.sc_code-info strong');
                    const scCodeTag = document.querySelector('#scDiscountApp .sc_simple-info__tag');
                    const subtotalCompareAt = document.querySelector('.Drawer__Footer__SubtotalPrice__CompareAt');

                    if (scCodeInfo && scCodeInfo.textContent.toLowerCase().includes('geschenkkarte')) {
                        scCodePercentage.style.display = 'none';
                        subtotalCompareAt.textContent = scData.totalFormatted;
                    }
                }, 1000);
            }
        }
    }
})();